const capRegistrationActions = {


    GET_CAP_COURSE_DOCUMENT: 'GET_CAP_COURSE_DOCUMENT',
    SET_CAP_COURSE_DOCUMENT: 'SET_CAP_COURSE_DOCUMENT',

    CREATE_CAP_COURSE_DOCUMENT: 'CREATE_CAP_COURSE_DOCUMENT',
    UPDATE_CAP_COURSE_DOCUMENT: 'UPDATE_CAP_COURSE_DOCUMENT',
    
    CREATE_CAP_COURSE: 'CREATE_CAP_COURSE',
    UPDATE_CAP_COURSE: 'UPDATE_CAP_COURSE',
    UPDATE_CAP_COURSE_STATUS: 'UPDATE_CAP_COURSE_STATUS',
    

    GET_CAP_CANDIDATURE: 'GET_CAP_CANDIDATURE',
    SET_CAP_CANDIDATURE: 'SET_CAP_CANDIDATURE',

    GET_ALL_CAP_COURSE: 'GET_ALL_CAP_COURSE',
    SET_ALL_CAP_COURSE: 'SET_ALL_CAP_COURSE',

    CREATE_CAP_CANDIDATURE: 'CREATE_CAP_CANDIDATURE',
    UPDATE_CAP_CANDIDATURE: 'UPDATE_CAP_CANDIDATURE',

    
    UPLOAD_DOCUMENT:'UPLOAD_DOCUMENT',
    REMOVE_DOCUMENT:'REMOVE_DOCUMENT',


    SET_ACTIVE_CAP_COURSE_DOC: 'SET_ACTIVE_CAP_COURSE_DOC',


    GET_CAP_CATEGORY: 'GET_CAP_CATEGORY',
    SET_CAP_CATEGORY: 'SET_CAP_CATEGORY',

    CREATE_CAP_CATEGORY: 'CREATE_CAP_CATEGORY',
    UPDATE_CAP_CATEGORY: 'UPDATE_CAP_CATEGORY',



};

export default capRegistrationActions;